var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42466 11.5753H2.42192L8.56575 5.43151L7.56849 4.43425L1.42466 10.5781V11.5753ZM11.611 4.39863L8.58356 1.40685L9.58082 0.409589C9.85388 0.13653 10.1894 0 10.5873 0C10.9848 0 11.3201 0.13653 11.5932 0.409589L12.5904 1.40685C12.8635 1.67991 13.0059 2.00948 13.0178 2.39556C13.0297 2.78117 12.8991 3.1105 12.626 3.38356L11.611 4.39863ZM10.5781 5.44932L3.0274 13H0V9.9726L7.55069 2.42192L10.5781 5.44932ZM8.06712 4.93288L7.56849 4.43425L8.56575 5.43151L8.06712 4.93288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4c63f66b63408aa63ad18ca02edc74d2.svg";
export { ForwardRef as ReactComponent };